var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477.319 237.383L392.793 205.737L359.769 193.369L393.601 103L256 154.523L118.394 103L152.231 193.374L119.207 205.742L34.6811 237.388L26 240.636L161.615 289.569C177.426 295.277 190.722 306.024 199.613 319.923C202.611 324.613 205.111 329.657 207.036 334.991L256 470.521L304.964 334.991C306.889 329.657 309.389 324.608 312.387 319.923C321.283 306.024 334.579 295.272 350.385 289.569L486 240.636L477.319 237.388V237.383ZM332.464 266.295C308.596 274.906 289.802 293.7 281.19 317.569L256.225 386.768L200.291 237.383L188.442 205.737L179.93 183.001L169.179 154.284L212.909 170.658L306.61 205.742L349.172 221.677L391.131 237.388L401.663 241.329L332.464 266.3V266.295Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ded957c3030f933dc755f6651dea0c3b.svg";
export { ForwardRef as ReactComponent };